import React, {useState, useEffect, forwardRef} from 'react';
import {useQuery} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
//DS
import SelectBase from '../../atomicos/SelectBase';
import {genQuery} from '../../../common/helpers';
import {SB_CARGANDO, SB_ERROR, SB_NO_DATA} from '../../../constants/componentValues';

const SelectGql = forwardRef((props, ref) => {
   const {entidad, campos, atributos, genElemento, recuperarOnFocus, client, ...other} = props;
   const query = genQuery(entidad, campos, atributos);
   const [options, setOptions] = useState([]);

   const {loading, error, data, refetch, networkStatus} = useQuery(
      gql`
         ${query}
      `,
      {
         notifyOnNetworkStatusChange: true,
         client
      }
   );

   useEffect(() => {
      if (data && data[entidad] && data[entidad].length > 0) {
         generarOptions(data[entidad]);
      }
   }, [data]);

   async function generarOptions(data) {
      let optionsD = await Promise.all(
         data.map(async (registro) => {
            return await genElemento(registro);
         })
      );
      setOptions(optionsD);
   }

   function onFocus() {
      if (recuperarOnFocus) {
         refetch();
      }
   }

   if (loading || networkStatus === 4) {
      let optionsCargando = [SB_CARGANDO];
      return <SelectBase options={optionsCargando} {...other} ref={ref} />;
   }

   if (error) {
      let optionsError = [SB_ERROR];
      return <SelectBase options={optionsError} {...other} ref={ref} />;
   }

   if (data[entidad] && data[entidad].length > 0 && options.length > 0) {
      if (options.length > 0) {
         return <SelectBase options={options} {...other} onFocus={onFocus} ref={ref} />;
      } else {
         let optionsCargando = [SB_CARGANDO];
         return <SelectBase options={optionsCargando} {...other} ref={ref} />;
      }
   }

   let optionsVacio = [SB_NO_DATA];
   return <SelectBase options={optionsVacio} {...other} onFocus={onFocus} ref={ref} />;
});

export default SelectGql;
